import * as ConnectionStatusActions from 'actions/ConnectionStatus';
import * as ConnectionStatus from 'constants/ConnectionStatus';

import {LIVE_INIT, LIVE_UPDATE, TIMETABLE_INIT, TIMETABLE_UPDATE} from 'sagas/actions';

export default function connectionStatusReducer(connectionStatus, action) {
    switch (action.type) {
        case ConnectionStatusActions.SET_CONNECTION_STATUS:
            return action.data;
        case LIVE_INIT.FAILURE:
        case LIVE_UPDATE.FAILURE:
        case TIMETABLE_INIT.FAILURE:
        case TIMETABLE_UPDATE.FAILURE:
            return ConnectionStatus.DISCONNECTED;
    }

    return connectionStatus;
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/connectionStatusReducer.js